import { mountCounter, counter } from 'dynamic-countdown'

// import notification library
import AWN from "awesome-notifications";

var moment = require('moment');

document.addEventListener("DOMContentLoaded", function(e) {
	counter();

	//#region Observer
	let complete_interval = false
	let redirect_on_completion = false;
	var observer = new MutationObserver(function(mutations) {
		mutations.forEach(function(mutationRecord) {
			clearInterval(complete_interval);
			complete_interval = setInterval(function() {
				document.body.classList.add('jd-reservation-expired');

				if(redirect_on_completion) {
					window.location.href = redirect_on_completion;
				}

				clearInterval(complete_interval);
			}, 2000);
		});    
	});
		
	//try attach this to the public facing reservation timer
	try {
		observer.observe(document.getElementById('reservation-time-remaining'), {subtree: true, childList: true});
	} catch(e) {
		try {
			observer.observe(document.getElementById('reservation-countdown'), {subtree: true, childList: true});
			redirect_on_completion = document.querySelector('input[name="vehicle_url"]').value;
		} catch(e) {
		}
	}
	//#endregion

	//#region Lock Request
	let purchase_form = document.getElementById('jd-purchase-form');
	let lock_requested = purchase_form && purchase_form.dataset.locked == "true" ? true : false;
	document.addEventListener('click', function (event) {
		if (!event.target.matches('.ff-btn-next')) return;

		if(lock_requested) {
			// new AWN().warning("This vehicle is already locked, you cannot further reserve it.");
			return;
		}

		var current_url = new URL(window.location.href);
		let parent_slide = event.target.parentNode.parentNode;
		let car_id = current_url.searchParams.get("car_id");

		//if we're on the first slide
		if(parent_slide.contains(document.querySelector('input[name="vehicle_id"]'))) {
			let first_name = document.querySelector('input[name="names[first_name]"]').value;
			let last_name = document.querySelector('input[name="names[last_name]"]').value;
			let email = document.querySelector('input[name="email"]').value;
			let phone = document.querySelector('input[name="phone"]').value;

			if(car_id && first_name && last_name && email && phone) {

				//indicate the user has requested a lock (so they can't do it again)
				lock_requested = true;

				//make a request to lock the car
				fetch(ajax_object.homeurl + "/wp-json/john-darke/vehicles/lock", { 
					method: "POST",
					body: JSON.stringify({
						"car": car_id,
						"first_name": first_name,
						"last_name": last_name,
						"email": email,
						"phone": phone
					}),
					headers: {
						"Accept": "*/*",
						"Content-Type": "application/json"
					}
				}).then(function(response) {
					return response.text();
				}).then(function(data) {
					let countdown = document.getElementById('reservation-countdown');
					const countdown_ticker = mountCounter(moment().add(30, 'minutes').format('M/D/Y H:mm'), 'MS', '2', 'en', 'primary-light-inverted')
					countdown.appendChild(countdown_ticker);
					counter();
					countdown.classList.add('active');

					new AWN().success("This vehicle is now temporarily locked for you. You have 30 minutes to complete your reservation before it expires.");
				});
			} else {
				new AWN().alert("Unable to lock this vehicle. Please fill out all fields on Slide 1 to prevent other users from reserving this vehicle.");
			}
		}
	});
	//#endregion
});